import { ILxsRegisterResources } from '../modules/lxs-register/lxs-register.props.autogenerated';

export interface ICountryOption {
    value: string;
    resourceKey: keyof ILxsRegisterResources;
}

export const COUNTRIES: ICountryOption[] = [
    { value: 'AF', resourceKey: 'lxsRegisterCountryAfghanistan' },
    { value: 'AL', resourceKey: 'lxsRegisterCountryAlbania' },
    { value: 'DZ', resourceKey: 'lxsRegisterCountryAlgeria' },
    { value: 'AD', resourceKey: 'lxsRegisterCountryAndorra' },
    { value: 'AO', resourceKey: 'lxsRegisterCountryAngola' },
    { value: 'AR', resourceKey: 'lxsRegisterCountryArgentina' },
    { value: 'AM', resourceKey: 'lxsRegisterCountryArmenia' },
    { value: 'AU', resourceKey: 'lxsRegisterCountryAustralia' },
    { value: 'AT', resourceKey: 'lxsRegisterCountryAustria' },
    { value: 'AZ', resourceKey: 'lxsRegisterCountryAzerbaijan' },
    { value: 'BS', resourceKey: 'lxsRegisterCountryBahamas' },
    { value: 'BH', resourceKey: 'lxsRegisterCountryBahrain' },
    { value: 'BD', resourceKey: 'lxsRegisterCountryBangladesh' },
    { value: 'BY', resourceKey: 'lxsRegisterCountryBelarus' },
    { value: 'BE', resourceKey: 'lxsRegisterCountryBelgium' },
    { value: 'BZ', resourceKey: 'lxsRegisterCountryBelize' },
    { value: 'BJ', resourceKey: 'lxsRegisterCountryBenin' },
    { value: 'BM', resourceKey: 'lxsRegisterCountryBermuda' },
    { value: 'BT', resourceKey: 'lxsRegisterCountryBhutan' },
    { value: 'BO', resourceKey: 'lxsRegisterCountryBolivia' },
    { value: 'BA', resourceKey: 'lxsRegisterCountryBosniaAndHerzegovina' },
    { value: 'BW', resourceKey: 'lxsRegisterCountryBotswana' },
    { value: 'BR', resourceKey: 'lxsRegisterCountryBrazil' },
    { value: 'BN', resourceKey: 'lxsRegisterCountryBrunei' },
    { value: 'BG', resourceKey: 'lxsRegisterCountryBulgaria' },
    { value: 'BF', resourceKey: 'lxsRegisterCountryBurkinaFaso' },
    { value: 'BI', resourceKey: 'lxsRegisterCountryBurundi' },
    { value: 'KH', resourceKey: 'lxsRegisterCountryCambodia' },
    { value: 'CM', resourceKey: 'lxsRegisterCountryCameroon' },
    { value: 'CA', resourceKey: 'lxsRegisterCountryCanada' },
    { value: 'CV', resourceKey: 'lxsRegisterCountryCapeVerde' },
    { value: 'CF', resourceKey: 'lxsRegisterCountryCentralAfricanRepublic' },
    { value: 'TD', resourceKey: 'lxsRegisterCountryChad' },
    { value: 'CL', resourceKey: 'lxsRegisterCountryChile' },
    { value: 'CN', resourceKey: 'lxsRegisterCountryChina' },
    { value: 'CO', resourceKey: 'lxsRegisterCountryColombia' },
    { value: 'KM', resourceKey: 'lxsRegisterCountryComoros' },
    { value: 'CG', resourceKey: 'lxsRegisterCountryCongo' },
    { value: 'CD', resourceKey: 'lxsRegisterCountryCongoDemocraticRepublic' },
    { value: 'CR', resourceKey: 'lxsRegisterCountryCostaRica' },
    { value: 'HR', resourceKey: 'lxsRegisterCountryCroatia' },
    { value: 'CU', resourceKey: 'lxsRegisterCountryCuba' },
    { value: 'CY', resourceKey: 'lxsRegisterCountryCyprus' },
    { value: 'CZ', resourceKey: 'lxsRegisterCountryCzechRepublic' },
    { value: 'DK', resourceKey: 'lxsRegisterCountryDenmark' },
    { value: 'DJ', resourceKey: 'lxsRegisterCountryDjibouti' },
    { value: 'DO', resourceKey: 'lxsRegisterCountryDominicanRepublic' },
    { value: 'EC', resourceKey: 'lxsRegisterCountryEcuador' },
    { value: 'EG', resourceKey: 'lxsRegisterCountryEgypt' },
    { value: 'SV', resourceKey: 'lxsRegisterCountryElSalvador' },
    { value: 'GQ', resourceKey: 'lxsRegisterCountryEquatorialGuinea' },
    { value: 'ER', resourceKey: 'lxsRegisterCountryEritrea' },
    { value: 'EE', resourceKey: 'lxsRegisterCountryEstonia' },
    { value: 'ET', resourceKey: 'lxsRegisterCountryEthiopia' },
    { value: 'FO', resourceKey: 'lxsRegisterCountryFaroeIslands' },
    { value: 'FI', resourceKey: 'lxsRegisterCountryFinland' },
    { value: 'FR', resourceKey: 'lxsRegisterCountryFrance' },
    { value: 'GA', resourceKey: 'lxsRegisterCountryGabon' },
    { value: 'GM', resourceKey: 'lxsRegisterCountryGambia' },
    { value: 'GE', resourceKey: 'lxsRegisterCountryGeorgia' },
    { value: 'DE', resourceKey: 'lxsRegisterCountryGermany' },
    { value: 'GH', resourceKey: 'lxsRegisterCountryGhana' },
    { value: 'GI', resourceKey: 'lxsRegisterCountryGibraltar' },
    { value: 'GR', resourceKey: 'lxsRegisterCountryGreece' },
    { value: 'GL', resourceKey: 'lxsRegisterCountryGreenland' },
    { value: 'GT', resourceKey: 'lxsRegisterCountryGuatemala' },
    { value: 'GN', resourceKey: 'lxsRegisterCountryGuinea' },
    { value: 'GW', resourceKey: 'lxsRegisterCountryGuineaBissau' },
    { value: 'HN', resourceKey: 'lxsRegisterCountryHonduras' },
    { value: 'HK', resourceKey: 'lxsRegisterCountryHongKong' },
    { value: 'HU', resourceKey: 'lxsRegisterCountryHungary' },
    { value: 'IS', resourceKey: 'lxsRegisterCountryIceland' },
    { value: 'IN', resourceKey: 'lxsRegisterCountryIndia' },
    { value: 'ID', resourceKey: 'lxsRegisterCountryIndonesia' },
    { value: 'IR', resourceKey: 'lxsRegisterCountryIran' },
    { value: 'IQ', resourceKey: 'lxsRegisterCountryIraq' },
    { value: 'IE', resourceKey: 'lxsRegisterCountryIreland' },
    { value: 'IL', resourceKey: 'lxsRegisterCountryIsrael' },
    { value: 'IT', resourceKey: 'lxsRegisterCountryItaly' },
    { value: 'CI', resourceKey: 'lxsRegisterCountryIvoryCoast' },
    { value: 'JP', resourceKey: 'lxsRegisterCountryJapan' },
    { value: 'JO', resourceKey: 'lxsRegisterCountryJordan' },
    { value: 'KZ', resourceKey: 'lxsRegisterCountryKazakhstan' },
    { value: 'KE', resourceKey: 'lxsRegisterCountryKenya' },
    { value: 'KW', resourceKey: 'lxsRegisterCountryKuwait' },
    { value: 'KG', resourceKey: 'lxsRegisterCountryKyrgyzstan' },
    { value: 'LV', resourceKey: 'lxsRegisterCountryLatvia' },
    { value: 'LB', resourceKey: 'lxsRegisterCountryLebanon' },
    { value: 'LS', resourceKey: 'lxsRegisterCountryLesotho' },
    { value: 'LR', resourceKey: 'lxsRegisterCountryLiberia' },
    { value: 'LY', resourceKey: 'lxsRegisterCountryLibya' },
    { value: 'LI', resourceKey: 'lxsRegisterCountryLiechtenstein' },
    { value: 'LT', resourceKey: 'lxsRegisterCountryLithuania' },
    { value: 'LU', resourceKey: 'lxsRegisterCountryLuxembourg' },
    { value: 'MO', resourceKey: 'lxsRegisterCountryMacau' },
    { value: 'MK', resourceKey: 'lxsRegisterCountryMacedonia' },
    { value: 'MG', resourceKey: 'lxsRegisterCountryMadagascar' },
    { value: 'MW', resourceKey: 'lxsRegisterCountryMalawi' },
    { value: 'MY', resourceKey: 'lxsRegisterCountryMalaysia' },
    { value: 'ML', resourceKey: 'lxsRegisterCountryMali' },
    { value: 'MT', resourceKey: 'lxsRegisterCountryMalta' },
    { value: 'MQ', resourceKey: 'lxsRegisterCountryMartinique' },
    { value: 'MR', resourceKey: 'lxsRegisterCountryMauritania' },
    { value: 'MU', resourceKey: 'lxsRegisterCountryMauritius' },
    { value: 'YT', resourceKey: 'lxsRegisterCountryMayotte' },
    { value: 'MX', resourceKey: 'lxsRegisterCountryMexico' },
    { value: 'MD', resourceKey: 'lxsRegisterCountryMoldova' },
    { value: 'MC', resourceKey: 'lxsRegisterCountryMonaco' },
    { value: 'MN', resourceKey: 'lxsRegisterCountryMongolia' },
    { value: 'MA', resourceKey: 'lxsRegisterCountryMorocco' },
    { value: 'MZ', resourceKey: 'lxsRegisterCountryMozambique' },
    { value: 'MM', resourceKey: 'lxsRegisterCountryMyanmar' },
    { value: 'NA', resourceKey: 'lxsRegisterCountryNamibia' },
    { value: 'NP', resourceKey: 'lxsRegisterCountryNepal' },
    { value: 'NL', resourceKey: 'lxsRegisterCountryNetherlands' },
    { value: 'NC', resourceKey: 'lxsRegisterCountryNewCaledonia' },
    { value: 'NZ', resourceKey: 'lxsRegisterCountryNewZealand' },
    { value: 'NI', resourceKey: 'lxsRegisterCountryNicaragua' },
    { value: 'NE', resourceKey: 'lxsRegisterCountryNiger' },
    { value: 'NG', resourceKey: 'lxsRegisterCountryNigeria' },
    { value: 'KP', resourceKey: 'lxsRegisterCountryNorthKorea' },
    { value: 'NO', resourceKey: 'lxsRegisterCountryNorway' },
    { value: 'OM', resourceKey: 'lxsRegisterCountryOman' },
    { value: 'PK', resourceKey: 'lxsRegisterCountryPakistan' },
    { value: 'PA', resourceKey: 'lxsRegisterCountryPanama' },
    { value: 'PG', resourceKey: 'lxsRegisterCountryPapuaNewGuinea' },
    { value: 'PY', resourceKey: 'lxsRegisterCountryParaguay' },
    { value: 'PE', resourceKey: 'lxsRegisterCountryPeru' },
    { value: 'PH', resourceKey: 'lxsRegisterCountryPhilippines' },
    { value: 'PL', resourceKey: 'lxsRegisterCountryPoland' },
    { value: 'PT', resourceKey: 'lxsRegisterCountryPortugal' },
    { value: 'PR', resourceKey: 'lxsRegisterCountryPuertoRico' },
    { value: 'QA', resourceKey: 'lxsRegisterCountryQatar' },
    { value: 'RE', resourceKey: 'lxsRegisterCountryReunion' },
    { value: 'RO', resourceKey: 'lxsRegisterCountryRomania' },
    { value: 'RU', resourceKey: 'lxsRegisterCountryRussia' },
    { value: 'RW', resourceKey: 'lxsRegisterCountryRwanda' },
    { value: 'SM', resourceKey: 'lxsRegisterCountrySanMarino' },
    { value: 'ST', resourceKey: 'lxsRegisterCountrySaoTomeAndPrincipe' },
    { value: 'SA', resourceKey: 'lxsRegisterCountrySaudiArabia' },
    { value: 'SN', resourceKey: 'lxsRegisterCountrySenegal' },
    { value: 'RS', resourceKey: 'lxsRegisterCountrySerbia' },
    { value: 'SC', resourceKey: 'lxsRegisterCountrySeychelles' },
    { value: 'SL', resourceKey: 'lxsRegisterCountrySierraLeone' },
    { value: 'SG', resourceKey: 'lxsRegisterCountrySingapore' },
    { value: 'SK', resourceKey: 'lxsRegisterCountrySlovakia' },
    { value: 'SI', resourceKey: 'lxsRegisterCountrySlovenia' },
    { value: 'SO', resourceKey: 'lxsRegisterCountrySomalia' },
    { value: 'ZA', resourceKey: 'lxsRegisterCountrySouthAfrica' },
    { value: 'KR', resourceKey: 'lxsRegisterCountrySouthKorea' },
    { value: 'ES', resourceKey: 'lxsRegisterCountrySpain' },
    { value: 'LK', resourceKey: 'lxsRegisterCountrySriLanka' },
    { value: 'SH', resourceKey: 'lxsRegisterCountryStHelena' },
    { value: 'SD', resourceKey: 'lxsRegisterCountrySudan' },
    { value: 'SJ', resourceKey: 'lxsRegisterCountrySvalbard' },
    { value: 'SZ', resourceKey: 'lxsRegisterCountrySwaziland' },
    { value: 'SE', resourceKey: 'lxsRegisterCountrySweden' },
    { value: 'CH', resourceKey: 'lxsRegisterCountrySwitzerland' },
    { value: 'SY', resourceKey: 'lxsRegisterCountrySyria' },
    { value: 'TW', resourceKey: 'lxsRegisterCountryTaiwan' },
    { value: 'TJ', resourceKey: 'lxsRegisterCountryTajikistan' },
    { value: 'TZ', resourceKey: 'lxsRegisterCountryTanzania' },
    { value: 'TH', resourceKey: 'lxsRegisterCountryThailand' },
    { value: 'TG', resourceKey: 'lxsRegisterCountryTogo' },
    { value: 'TT', resourceKey: 'lxsRegisterCountryTrinidadAndTobago' },
    { value: 'TN', resourceKey: 'lxsRegisterCountryTunisia' },
    { value: 'TR', resourceKey: 'lxsRegisterCountryTurkey' },
    { value: 'TM', resourceKey: 'lxsRegisterCountryTurkmenistan' },
    { value: 'UG', resourceKey: 'lxsRegisterCountryUganda' },
    { value: 'UA', resourceKey: 'lxsRegisterCountryUkraine' },
    { value: 'AE', resourceKey: 'lxsRegisterCountryUnitedArabEmirates' },
    { value: 'GB', resourceKey: 'lxsRegisterCountryUnitedKingdom' },
    { value: 'US', resourceKey: 'lxsRegisterCountryUsa' },
    { value: 'UY', resourceKey: 'lxsRegisterCountryUruguay' },
    { value: 'UZ', resourceKey: 'lxsRegisterCountryUzbekistan' },
    { value: 'VA', resourceKey: 'lxsRegisterCountryVaticanCity' },
    { value: 'VE', resourceKey: 'lxsRegisterCountryVenezuela' },
    { value: 'VN', resourceKey: 'lxsRegisterCountryVietnam' },
    { value: 'VI', resourceKey: 'lxsRegisterCountryVirginIslands' },
    { value: 'YE', resourceKey: 'lxsRegisterCountryYemen' },
    { value: 'ZM', resourceKey: 'lxsRegisterCountryZambia' },
    { value: 'ZW', resourceKey: 'lxsRegisterCountryZimbabwe' }
];
